"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECEIVE_GATES_UPDATE = void 0;
exports.RECEIVE_GATES_UPDATE = '@gates/RECEIVE_GATES_UPDATE';